export enum TableGameHandStatus {

    Disabled = <any>'disabled',

    Enabled = <any>'enabled',

    Active = <any>'active',

    Finnished = <any>'finnished',
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Types/TableGameHandStatus.ts
 **/